// extracted by mini-css-extract-plugin
export var emailBlockLink = "_k1-0";